// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideVideo as RawLucideVideo } from "lucide-react";
export const LucideVideo = /* @__PURE__ */ createIcon(RawLucideVideo, "LucideVideo", 2);
